import factory from './icon';
import Bag from './Glyphs/Bag.svg';

export const Bag16x16 = factory(Bag, 16, 16);
